import { Button } from '@/components/ui/button'
import { useFormContext } from 'react-hook-form'
import { defaultLegacyFormColors } from '../../TeamApplicants/utils'

const ResetLegacyFormColorsButton = () => {
  const form = useFormContext()

  return (
    <Button
      variant='outline'
      type='button'
      size='sm'
      className='w-24'
      onClick={() => {
        for (const [key, value] of Object.entries(defaultLegacyFormColors)) {
          form.setValue(`recruitmentDetails.${key}`, value)
        }

        form.setValue('resetToDefaultAt', new Date().toISOString())
      }}
    >
      Reset
    </Button>
  )
}

export default ResetLegacyFormColorsButton
